import React from 'react';
import { SocialEditor } from 'js/social/shared/SocialEditor/SocialEditor';
import { Tag, Hashtag } from '../shared/types';

interface Props {
  content: string;
  tags?: Tag[];
  hashtags?: Hashtag[];
  allowAllHashtags?: boolean;
  trackImpressions?: boolean;
  className?: string;
  isQuotedNews?: boolean;
  isSinglePostPage?: boolean;
  isTextOnly?: boolean;
  impressionExtraData?: Record<string, unknown>;
  impressionSourceRoot?: string;
}

export const PostBody: React.FunctionComponent<Props> = ({
  content,
  tags = [],
  hashtags = [],
  allowAllHashtags = false,
  trackImpressions = false,
  className,
  isQuotedNews,
  isSinglePostPage,
  isTextOnly,
  impressionExtraData,
  impressionSourceRoot,
}) => {
  const lines = isSinglePostPage
    ? undefined
    : isQuotedNews
    ? 1
    : isTextOnly
    ? 5
    : 2;

  return (
    <div className={className} style={{ paddingLeft: isQuotedNews ? 48 : 0 }}>
      <SocialEditor
        readOnly
        content={content}
        tags={tags}
        allowedHashtags={
          allowAllHashtags
            ? undefined
            : hashtags.map((hashtag) => hashtag.hashtag)
        }
        lines={lines}
        trackImpressions={trackImpressions}
        impressionExtraData={impressionExtraData}
        impressionSourceRoot={impressionSourceRoot}
      />
    </div>
  );
};
